import { appColors, BackrsIcon } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Box, Typography, SxProps, Theme } from '@mui/material';

import { ResultsPill } from './ResultsPill';

const BACKRS_URL = process.env.REACT_APP_BACKRS_URL;
const PROSPER_URL = process.env.REACT_APP_GROW_URL;
const LUBAV_URL = process.env.REACT_APP_GROW_URL;

const MARKERS_OF_SUCCESS_STRINGS = appStrings.modules.results;

export const SuccessMoreInfo = () => {
  return (
    <Box sx={successMoreInfoStyle}>
      <ResultsPill title={MARKERS_OF_SUCCESS_STRINGS.moreInfo.title} />
      <Typography variant="h6" sx={backrsLinkMoreInfo}>
        {MARKERS_OF_SUCCESS_STRINGS.moreInfo.forSupport}
      </Typography>
      <Box sx={iconTextContainer} onClick={() => window.open(BACKRS_URL, '_blank')}>
        <BackrsIcon name="BackrsFilledDropShadow" alt="Backrs Logo" height={70} width={70} />
        <Typography variant="body1" sx={textStyle}>
          {MARKERS_OF_SUCCESS_STRINGS.moreInfo.information.backrs}
        </Typography>
      </Box>
      <Box sx={iconTextContainer} onClick={() => window.open(PROSPER_URL, '_blank')}>
        <BackrsIcon name="ProsperFilledDropShadow" alt="Prosper Logo" height={70} width={70} />
        <Typography variant="body1" sx={textStyle}>
          {MARKERS_OF_SUCCESS_STRINGS.moreInfo.information.prosper}
        </Typography>
      </Box>
      <Box sx={iconTextContainer} onClick={() => window.open(LUBAV_URL, '_blank')}>
        <BackrsIcon name="LubavFilledDropShadow" alt="Lubav Logo" height={70} width={70} />
        <Typography variant="body1" sx={textStyle}>
          {MARKERS_OF_SUCCESS_STRINGS.moreInfo.information.lubav}
        </Typography>
      </Box>
    </Box>
  );
};

const successMoreInfoStyle: SxProps<Theme> = {
  backgroundColor: appColors.neutral.white,
  border: `2px solid ${appColors.neutral.black}`,
  borderRadius: '.5rem',
  height: 'fit-content',
  paddingX: {
    xs: '1rem',
    sm: '2rem',
  },
  paddingY: '2rem',
  width: {
    xs: 'unset',
    sm: 'unset',
    md: '100%',
  },
};

const iconTextContainer: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  width: '100%',
  mt: 2,
  cursor: 'pointer',
};

const backrsLinkMoreInfo: SxProps<Theme> = {
  fontWeight: 700,
  my: 2,
  lineHeight: '1.25',
};

const textStyle: SxProps<Theme> = {
  fontSize: '1rem',
  fontWeight: 600,
  color: appColors.neutral.black,
  lineHeight: '1.3',
  width: '100%',
};
